import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Tracks the user's `prefers-reduced-motion` OS/browser preference so
 * components can skip or simplify animations for people who opt out of
 * motion. Reacts live if the preference changes while the app is open.
 */
export function useReducedMotion(): boolean {
    const [prefersReduced, setPrefersReduced] = useState<boolean>(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return false;
        return window.matchMedia(QUERY).matches;
    });

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return;
        const mediaQuery = window.matchMedia(QUERY);

        const handleChange = (event: MediaQueryListEvent) => {
            setPrefersReduced(event.matches);
        };

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return prefersReduced;
}

export default useReducedMotion;
